import { render, staticRenderFns } from "./BasePasswordFormItem.vue?vue&type=template&id=a6ec95f2"
import script from "./BasePasswordFormItem.vue?vue&type=script&lang=js"
export * from "./BasePasswordFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports